RivalIQ.apps.Favorites.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.WidgetConfiguration = RivalIQ.apps.Dashboard.models.WidgetConfiguration.extend({
        url: function () {
            const me = this;
            return me.parent.url();
        }
    });

    models.Configuration = RivalIQ.apps.Dashboard.models.Configuration.extend({
        parse: function (attrs) {
            attrs.name = _.unescape(attrs.name);
            return attrs;
        },

        sync: function (method, child, options) {
            if (!options.subresource) {
                options.attrs = _.omit(child.attributes, 'landscape_id', 'account_id', 'type');
                if (options.attrs.parent_widget_curation_configuration_id === -1) {
                    delete options.attrs.parent_widget_curation_configuration_id;
                }
            }

            options.attrs.name = _.escape(options.attrs.name);

            return Backbone.sync.apply(this, arguments);
        },

        parentConfiguration: function () {
            const me = this;
            return new models.Configuration(_.omit(me.attributes, 'instanceId'));
        },

        validate: function (data, options) {
            const errors = [];

            if (!data.name || $.trim(data.name).length === 0) {
                errors.push(['name', 'Name is required']);
            }

            if (data.name && _.escape(data.name).length > 99) {
                errors.push(['name', 'Name is too long']);
            }

            if (!data.type) {
                errors.push(['type', 'Type is required']);
            }

            if (options.copy) {
                if (options.copy === App.enums.copyMode.DASHBOARD && !data.parent_widget_curation_configuration_id) {
                    errors.push(['parent_widget_curation_configuration_id', 'Dashboard is required']);
                } else if (options.copy === App.enums.copyMode.TEMPLATE && !data.definitions) {
                    errors.push(['parent_widget_curation_configuration_id', 'Template is required']);
                }
            }

            return (errors.length ? errors : null);
        }
    });

    models.EditConfiguration = models.Configuration.extend({
        url: function (options) {
            const me = this;
            options = options || {};

            const url = models.Configuration.prototype.url.call(me);

            if (options.widget) {
                return url;
            }

            return [url, 'definitions', me.get('instanceId'), 'edit'].join('/');
        }
    });

    models.NewConfiguration = models.Configuration.extend({
        url: function () {
            const me = this;

            const url = models.Configuration.prototype.url.call(me);

            return [url, 'definitions', 'new'].join('/');
        }
    });
});
